import { Component } from '@verndale/core';
import InputDate from '../components/inputDate';
import InputField from '../components/inputFieldForm';
import Dropdown from '../components/dropdown';

class Module extends Component {
  setupDefaults() {
    this.initFields();
  }

  addListeners() {
    window.addEventListener('initFormComponents', this.reloadFields.bind(this));
  }

  filterBuiltDropdowns(dropdown) {
    const parent = dropdown.parentNode;
    const button = parent.querySelector('.dropdown__trigger');
    const list = parent.querySelector('.dropdown__list');

    return !(button && list);
  }

  initFields() {
    const inputFields = this.el.querySelectorAll('.form-input');
    const dropdowns = this.el.querySelectorAll('.form-group--dropdown select');
    const inputDates = this.el.querySelectorAll('.form-group--datepicker');

    inputFields.forEach(input => new InputField(input));
    inputDates.forEach(input => new InputDate(input));
    [...dropdowns]
      .filter(this.filterBuiltDropdowns)
      .forEach(dropdown => new Dropdown(dropdown));
  }

  reloadFields() {
    const form = this.el.querySelector('.form');

    if (form) {
      window.scroll(0, form.offsetTop - 60);
    }

    this.initFields();
  }
}

export default Module;
